<template>
    <div class="o-grid o-grid--center u-m-b7" v-if="!!cards.length">
        <div class="c-post-click o-grid__item u-width-10/12 u-width-full@s">
            <h5 class="u-m-b4 u-m-b3@s">Related Content</h5>
            <div class="c-cards__related_content" data-cy="related-content">
                <VueSlickCarousel v-bind="slickSettings">
                    <post-card-api
                        v-for="card in cards"
                        :key="card.id"
                        :card="card"
                    ></post-card-api>
                </VueSlickCarousel>
            </div>
        </div>
        <a v-if="$root.user !== false" :href="'/post/create/' + $root.community.url" class="c-article__add"></a>
        <a v-else @click.prevent="showMemberPanel" class="c-article__add"></a>
    </div>
</template>

<script>
import PostCardApi from "../PostCardApi.vue";
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    components: {
        VueSlickCarousel,
        PostCardApi
    },
    data() {
        return {
            cards: [],
            slickSettings: {
                'adaptiveHeight': true,
                'arrows': false,
                'responsive': [
                    {
                        'breakpoint': 9999,
                        'settings': 'unslick'
                    },
                    {
                        'breakpoint': 768,
                        'settings': {
                            'slidesToShow': 1,
                            'slidesToScroll': 1,
                            'autoplay': true,
                            'autoplaySpeed': 4000,
                            'dots': true,
                            'fade': true,
                            'infinite': true
                        }
                    }
                ]
            }
        }
    },
    created() {
        // fetch the data when the view is created and the data is
        // already being observed
        this.fetchData();
    },
    methods: {
        fetchData() {
            this.$http.get('/api/v1/posts/related/' + this.$root.community.id + '/' + this.$root.dyadey_id, {}).then(response => {
                this.cards = response.data.cards;
            }, response => {
                console.log('Errored:');
                console.log(response);
            });
        },
        showMemberPanel() {
            this.$simpleStore.showMemberPanel(this);
        }
    },
    mounted() {
        /*this.onCommunityScroll();
        this.$root.$on('update-cards', this.updateCards);
        this.$root.$on('reset-cards', this.resetCards);*/
    }
}
</script>
